interface Props {
  score: number;
  size?: "lg" | "sm";
  label?: string;
}

function colorForScore(score: number): { stroke: string; text: string } {
  if (score >= 80) return { stroke: "#16a34a", text: "text-green-600" };
  if (score >= 60) return { stroke: "#0891b2", text: "text-cyan-600" };
  if (score >= 40) return { stroke: "#d97706", text: "text-amber-600" };
  return { stroke: "#dc2626", text: "text-red-600" };
}

export default function ScoreGauge({ score, size = "lg", label }: Props) {
  const safe = Math.max(0, Math.min(100, score));
  const dimension = size === "lg" ? 200 : 96;
  const stroke = size === "lg" ? 14 : 8;
  const radius = (dimension - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - safe / 100);
  const color = colorForScore(safe);

  return (
    <div className="inline-flex flex-col items-center gap-2">
      <div
        className="relative"
        style={{ width: dimension, height: dimension }}
      >
        <svg
          width={dimension}
          height={dimension}
          className="transform -rotate-90"
          aria-hidden
        >
          <circle
            cx={dimension / 2}
            cy={dimension / 2}
            r={radius}
            stroke="#e5e7eb"
            strokeWidth={stroke}
            fill="none"
          />
          <circle
            cx={dimension / 2}
            cy={dimension / 2}
            r={radius}
            stroke={color.stroke}
            strokeWidth={stroke}
            fill="none"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            style={{ transition: "stroke-dashoffset 600ms ease" }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span
            className={`${color.text} font-semibold ${
              size === "lg" ? "text-5xl" : "text-2xl"
            }`}
          >
            {safe}
          </span>
          {size === "lg" && (
            <span className="text-ink-400 text-sm mt-1">out of 100</span>
          )}
        </div>
      </div>
      {label && (
        <div className="text-ink-600 text-sm font-medium">{label}</div>
      )}
    </div>
  );
}
